(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faienca-product-styles"]) return;
  try {
    
  (function initFaiencaPdpDescriptionItems() {
    if (window.__faiencaPdpDescriptionItemsInit) return;
    window.__faiencaPdpDescriptionItemsInit = true;

    const splitters = [' – ', ' — ', ' - '];

    function formatDetailListItem(li) {
      if (li.dataset.faiencaDetailFormatted === 'true') return;

      const text = li.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;

      let splitAt = -1;
      let splitter = '';

      for (const candidate of splitters) {
        const index = text.indexOf(candidate);
        if (index > 0) {
          splitAt = index;
          splitter = candidate;
          break;
        }
      }

      if (splitAt === -1) return;

      const title = text.slice(0, splitAt).trim();
      const definition = text.slice(splitAt + splitter.length).trim();
      if (!title || !definition) return;

      li.dataset.faiencaDetailFormatted = 'true';
      li.classList.add('faienca-pdp-detail-item');
      li.replaceChildren();

      const titleEl = document.createElement('span');
      titleEl.className = 'faienca-pdp-detail-item__title';
      titleEl.textContent = `${title} `;

      const defEl = document.createElement('span');
      defEl.className = 'faienca-pdp-detail-item__def';
      defEl.textContent = `(${definition})`;

      li.append(titleEl, defEl);
    }

    function formatDescriptionLists(root = document) {
      root.querySelectorAll('.faienca-pdp-details .details--description .text-block li').forEach(formatDetailListItem);
    }

    formatDescriptionLists();

    document.addEventListener('shopify:section:load', (event) => {
      formatDescriptionLists(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
